<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
		[isImportable]="isImportable"
		[isExportable]="isExportable"
		(importingEvent)="uploader.click()"
		(exportingEvent)="exportMissionPlaces()"
	></app-nav-gestion-donnees>

	<input hidden type="file" #uploader (change)="importMissionPlaces($event)" />
	<div class="row my-3">
		<div class="row my-2">
			<div class="col-2 ms-lg-auto">
				<div class="dropdown">
					<a
						class="btn btn-secondary dropdown-toggle"
						role="button"
						id="dropdownFilter"
						data-bs-toggle="dropdown"
						data-bs-auto-close="outside"
						aria-expanded="false"
					>
						<i class="bi bi-filter" aria-hidden="true"></i> Filtrer
					</a>
					<div
						class="dropdown-menu px-3 py-3"
						aria-labelledby="dropdownFilter"
						id="menuFilter"
					>
						<div class="row">
							<span class="theme-main-color form-label">Spécialité(s)</span>
							<div class="mb-1">
								<div
									class="form-check ms-3"
									*ngFor="let specialite of listSpecialite"
								>
									<input
										type="checkbox"
										name="{{ specialite.id }}"
										class="form-check-input"
										[value]="specialite"
										(change)="updateSelectedSpecialite($event, specialite)"
									/>
									<label class="form-check-label text-dark">
										{{ specialite.name }}
									</label>
								</div>
							</div>

							<div class="row d-flex flex-row-reverse">
								<button
									class="btn theme-green-button w-50"
									(click)="filterListBySpecialties()"
								>
									Filtrer
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-4 col-12 ps-lg-5">
				<div class="input-group">
					<span class="input-group-text bg-transparent"
						><i class="bi bi-search" aria-hidden="true"></i
					></span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="Nom(s), prénom(s), adresse"
						[(ngModel)]="searchedInput"
						(keyup)="onKeyUp()"
					/>
				</div>
			</div>
		</div>

		<div *ngIf="!isMobile" class="row mt-4">
			<div class="col-lg-3 col-12">
				<span class="ps-1 hand-cursor fw-bold" (click)="sortChange('name')"
					>Nom
					<span
						*ngIf="sortType === 'name' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'name' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>

			<div *ngIf="!isMobile" class="col-lg-5 col-12">
				<span
					class="ps-1 hand-cursor fw-bold"
					(click)="sortChange('address.label')"
					>Adresse
					<span
						*ngIf="sortType === 'address.label' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'address.label' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div *ngIf="!isMobile" class="col-lg-4 col-12">
				<span
					class="ps-1 hand-cursor fw-bold"
					(click)="sortChange('specialties[0].name')"
					>Spécialité(s)
					<span
						*ngIf="sortType === 'specialties[0].name' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'specialties[0].name' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
		</div>

		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<div *ngIf="!isListingLoading" class="mt-4">
			<div
				*ngFor="
					let missionPlace of missionPlaces
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage,
									totalItems: totalItems
							  }
						| orderBy : sortType : sortOrder
				"
				class="row my-1 pt-3 pb-1 rounded rounded-3 bg-light"
			>
				<span class="col-lg-3 col-12">
					<span *ngIf="isMobile" class="fw-bold"> Nom : </span>
					{{ missionPlace?.name | titlecase }}
				</span>

				<span class="col-lg-5 col-12">
					<span *ngIf="isMobile" class="fw-bold"> Adresse : </span>
					{{ missionPlace?.address?.label }}
				</span>

				<div class="col-lg-4 col-12">
					<div class="d-flex">
						<span class="flex-grow-1">
							<span *ngIf="isMobile" class="fw-bold"> Spécialité(s) : </span>

							<span
								*ngFor="let spe of missionPlace.specialties; let ilast = last"
								class="me-1"
								>{{ ' ' + spe.name }}{{ ilast ? '' : ',' }}</span
							></span
						>
						<i
							[routerLink]="['/gestion/mission-places', missionPlace?.id]"
							role="button"
							class="fs-4 bi bi-caret-right-fill mb-1"
							aria-hidden="true"
						></i>
					</div>
				</div>
			</div>
		</div>
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="pageHasChanged($event)"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
		</div>
	</div>
</div>
